import {useDispatch} from "react-redux";
import {
  useDeletePaymentMethodMutation,
} from "../../../Store/Builder/techsbook.api";
import {setLoader} from "../../../Store/Slice/techsbookSlice";
import showToast from "../../Hooks/toast";

const useDeletePaymentMethodApi = () => {
  const dispatch = useDispatch();
  const [handleDelete] = useDeletePaymentMethodMutation();

  const send = (body, closeModal, onSuccess) => {
    dispatch(setLoader(true));
    handleDelete(body)
      .unwrap()
      .then((res) => {
        dispatch(setLoader(false));
        showToast(res?.message, "success");
        closeModal();
        onSuccess();
      })
      .catch((err) => {
        dispatch(setLoader(false));
        showToast(err?.data?.message ?? "Error", "error");
      });
  };

  return {
    send,
  };
};

export default useDeletePaymentMethodApi;
